// @flow
import React, { Component } from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";

import MobileSlideshow from "./MobileSlideshow";
import { withListingContext } from "./ListingContext";
import { withGlobalContext } from "../common/GlobalContext";
import type {
  CompliantListingType,
  $OpenHouses,
  ComplianceListingItems,
} from "flow/types";

type $Props = {
  classes: Object,
  className: string,
  compliance: ComplianceListingItems,
  listing: CompliantListingType,
  openHouses: $OpenHouses,
  CDN_IMAGE_SERVER_URL: string,
  isV1: number,
};

type $State = {
  photos: Array<string>,
};

class MobileGallery extends Component<$Props, $State> {
  constructor(props) {
    super(props);

    const { listing, CDN_IMAGE_SERVER_URL, isV1 } = props;
    let photos = [];

    if (listing.photos && listing.photos.length) {
      if (isV1) {
        photos = listing.photos.map(
          (photo) => `${CDN_IMAGE_SERVER_URL}/${photo.path}?hash=${photo.hash}`
        );
      } else {
        photos = listing.photos.map((photo) => `${photo.path}`);
      }
    }

    this.state = {
      photos,
    };
  }

  render() {
    const { classes, className, compliance } = this.props;
    const { photos } = this.state;

    return (
      <div className={classNames(classes.root, className)}>
        <MobileSlideshow photos={photos} compliance={compliance} />
      </div>
    );
  }
}

export default withStyles((theme) => ({
  root: {},
  photo: {
    display: "flex",
    ".ie-11 &": {
      display: "inline-block",
    },

    "&:focus": {
      outline: "2px solid #fff", // override blue focus ring with white solid ring
    },
  },
  img: {
    width: "100%",
    height: "100%",
  },
  tag: {
    position: "absolute",
    top: "8px",
    left: "8px",
  },
  closeButton: {
    position: "absolute",
    top: "8px",
    right: "8px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: theme.colors.white,
    padding: theme.spacing.unit * 0.5,
    zIndex: theme.zIndex["modalControl"],
    background: "rgba(0,0,0,0.5)",
    borderRadius: theme.globalBorderRadius,

    "&:focus": {
      outline: "2px solid #fff !important", // override blue focus ring with white solid ring
    },
  },
}))(withGlobalContext(withListingContext(MobileGallery)));
